import React from 'react';
import { IPanelButton } from '../../../interfaces/buttons/buttons';


const PanelButton = ({ content, ariaLabel, className, isDisabled = false, onButtonClick}: IPanelButton) => {
    if (!content) {
        return <></>
    }
    return (
        <button
            className={`panel-button ${className ?? ""}`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
            type={'button'}
        >
            {content}
        </button>
    );
};

export default PanelButton